import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Image, Flex, Box } from '@chakra-ui/react';
import { redirectToLandingPage } from '../../global/helpers/global-helpers';

import logo from '../../global/styles/images/launchdeck_logo.svg';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';

function UnauthorisedAccessDisplay({ isMobileView }) {

	return (
		<Box w={isMobileView && '90%'} margin='auto'>
			<Box alignItems='center' bg='white' rounded='0.25em' p='1em'>
				<Flex w='100%' justify='center' p='1.5em'>
					<Image src={logo} alt="Launchdeck Logo" width='50%' minWidth='15em' maxWidth='20em' mb='2em' onClick={() => redirectToLandingPage()} />
				</Flex>

				<Box direction='column' maxWidth='37.5em' minW='30em'  m='auto'>
					<Flex direction='column' alignItems='center' bg='white' rounded='0.25em' >
						<Box w='100%' py='0.8em' textAlign='center'>
							<Box w='100%' fontSize='1.1em' lineHeight='1.875em' fontWeight='600' textAlign='center'>Unable to authorise</Box>
							<Box  fontSize='0.875em' px='0.5em'>
								Make sure your contact has provided the right link and code
							</Box>
						</Box>


						<Box w='100%' p='1em 1.5em' mt='3em' >
							<Flex alighItems='center' justify='center'>
								<LaunchdeckButton bg='brand.500' color='white' onClick={() => redirectToLandingPage()} label='Return to Launchdeck' />
							</Flex>
						</Box>

					</Flex>
				</Box>
			</Box>
		</Box>
	);
}

function mapStateToProps(state) {
	return {
		isMobileView: state.mobileViewMode.isMobileView
	};
}


export default withRouter(connect(mapStateToProps, null)(UnauthorisedAccessDisplay));
